import SoundToggle from '../../components/SoundFx/SoundToggle';
import SoundFx from '../../components/SoundFx';

export default function initAudio() {
  const a11yAudioActivator = document.getElementById('SoundToggle');
  const disableAudio = new SoundToggle(a11yAudioActivator, SoundFx);

  disableAudio.init();
}
